import styled from 'styled-components';

export const Minimize = styled.button`
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: 0;
  width: 70px;
  padding: 20px;
  border: none;
  outline: none;
  position: absolute;
  cursor: pointer;
  background: none;
  -webkit-tap-highlight-color: transparent;
  @media (hover: hover) {
    :hover {
      :after {
        background: #f9703e;
      }
    }
  }
  &:after {
    content: '';
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    top: 5px;
    width: 30px;
    height: 5px;
    border: none;
    outline: none;
    border-radius: 20px;
    position: absolute;
    background: var(--l-grey);
    /* z-index: 10; */
  }
`;
